export const roundTo2Decimal = (num) => {
    return Math.round((num + Number.EPSILON) * 100) / 100;
};

export const roundTo1Decimal = (num) => {
    return Math.round((num + Number.EPSILON) * 10) / 10;
};